import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const GroupName = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  flex: 1;
  margin: 0;
`;

export const GroupCount = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  margin: 0 0 0 10px;
`;
